import axios from 'axios';

const baseUrl = `${process.env.REACT_APP_LMS_API}api/MicrocredentialsManagement`;
// Example final endpoints in .NET (you can match these):
// GET    /api/MicrocredentialsManagement/courses
// POST   /api/MicrocredentialsManagement/courses
// PUT    /api/MicrocredentialsManagement/courses/{id}
// DELETE /api/MicrocredentialsManagement/courses/{id}
// GET    /api/MicrocredentialsManagement/courses/{courseId}/topics
// POST   /api/MicrocredentialsManagement/topics
// PUT    /api/MicrocredentialsManagement/topics/{id}
// DELETE /api/MicrocredentialsManagement/topics/{id}

export async function getCourses() {
   const response = await axios.get(`${baseUrl}/courses`);
   return response.data;
}

export async function createCourse(payload) {
   const response = await axios.post(`${baseUrl}/courses`, payload, {
      headers: payload instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
   });
   return response.data;
}

export async function updateCourse(id, payload) {
   const response = await axios.put(`${baseUrl}/courses/${id}`, payload, {
      headers: payload instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
   });
   return response.data;
}

export async function deleteCourse(id) {
   const response = await axios.delete(`${baseUrl}/courses/${id}`);
   return response.data;
}

export async function getTopicsByCourse(courseId) {
   const response = await axios.get(`${baseUrl}/courses/${courseId}/topics`);
   return response.data;
}

export async function createTopic(payload) {
   const response = await axios.post(`${baseUrl}/topics`, payload, {
      headers: payload instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
   });
   return response.data;
}

export async function updateTopic(id, payload) {
   const response = await axios.put(`${baseUrl}/topics/${id}`, payload, {
      headers: payload instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
   });
   return response.data;
}

export async function deleteTopic(id) {
   const response = await axios.delete(`${baseUrl}/topics/${id}`);
   return response.data;
}
